import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class ClassroomAPI extends BaseAPI {}

export default new ClassroomAPI('v1/student-classrooms', 'StudentClassroom')
